<template>
  <!-- CREATE USER -->
  <v-dialog
    v-model="createCustomerModal"
    persistent
    max-width="900px"
  >
    <v-card>
      <form @submit.prevent="submitForm()">
        <v-card-title style="padding-bottom: 0px">
          <v-flex
            xs11
            sm11
            md11
          ><span class="headline">Add Customer</span></v-flex>
          <v-flex
            xs1
            sm1
            md1
          >
            <v-btn
              flat
              @click=";(passwordAlert = false), closeCreateCustomerModal(), $validator.reset()"
              class="close"
            ><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
          </v-flex>
        </v-card-title>
        <v-card-text>
          <v-layout wrap>
            <v-flex
              xs12
              sm10
              md6
              class="px-2"
            >
              <v-text-field
                label="Customer Name*"
                v-model="addData.full_name"
                :error-messages="errors.collect('Customer Name')"
                data-vv-name="Customer Name"
                v-validate="'required'"
              ></v-text-field>
            </v-flex>

            <v-flex
              xs12
              sm10
              md6
              class="px-2"
            >
              <v-text-field
                label="Email"
                v-model="addData.email"
                :error-messages="errors.collect('email')"
                v-validate="'email'"
                data-vv-name="email"
              ></v-text-field>
            </v-flex>

            <v-flex
              xs12
              sm10
              md6
              class="px-2"
            >
              <v-text-field
                label="Phone Number*"
                v-model="addData.phone_number"
                :error-messages="errors.collect('Phone Number')"
                v-validate="'required'"
                data-vv-name="Phone Number"
              ></v-text-field>
            </v-flex>

            <v-flex
              xs12
              sm10
              md6
              class="px-2"
            >
              <v-text-field
                label="Phone Number 2"
                v-model="addData.phone_number_2"
                :error-messages="errors.collect('Phone Number 2')"
                data-vv-name="Phone Number 2"
              ></v-text-field>
            </v-flex>

            <v-flex
              class="px-2"
              xs12
              sm6
              md6
            >
              <v-select
                autocomplete
                :items="citiesList"
                item-value="city_id"
                item-text="city_name"
                v-model="addData.city_id_fk"
                :error-messages="errors.collect('City')"
                data-vv-name="City"
                label="City"
                clearable
              >
              </v-select>
            </v-flex>

            <v-flex
              xs12
              sm10
              md6
              class="px-2"
            >
              <v-text-field
                label="Address"
                v-model="addData.address"
                data-vv-name="address"
              ></v-text-field>
            </v-flex>

            <v-flex
              xs12
              sm10
              md6
              class="px-2"
            >
              <v-text-field
                :label="
                      'Price per wight (USA) (By default $' +
                        defaultPriceData.customer_price_per_weight_usa +
                        ')'
                    "
                v-model.number="addData.item_weight_price_usa"
                data-vv-name="item_weight_price_usa"
              ></v-text-field>
            </v-flex>

            <v-flex
              xs12
              sm10
              md6
              class="px-2"
            >
              <v-text-field
                :label="
                      'Price per wight (Turkey) (By default $' +
                        defaultPriceData.customer_price_per_weight_turkey +
                        ')'
                    "
                v-model.number="addData.item_weight_price_turkey"
                data-vv-name="item_weight_price_turkey"
              ></v-text-field>
            </v-flex>

            <v-flex
              xs12
              sm10
              md6
              class="px-2"
            >
              <v-text-field
                :label="
                      'Base Quantity Charge (Turkey) (By default $' +
                        defaultPriceData.customer_base_qtt_charge_turkey +
                        ')'
                    "
                v-model.number="addData.quantity_charge_base_turkey"
                data-vv-name="quantity_charge_base_turkey"
              ></v-text-field>
            </v-flex>
            <v-flex
              xs12
              sm10
              md6
              class="px-2"
            >
              <v-text-field
                :label="
                      'Other Quantity Charge (Turkey) (By default $' +
                        defaultPriceData.customer_other_qtt_charge_turkey +
                        ')'
                    "
                v-model.number="addData.quantity_charge_other_turkey"
                data-vv-name="quantity_charge_other_turkey"
              ></v-text-field>
            </v-flex>

            <v-flex
              xs12
              sm10
              md6
              class="px-2"
            >
              <v-text-field
                :label="
                      'Base Quantity Charge (USA) (By default $' +
                        defaultPriceData.customer_base_qtt_charge_usa +
                        ')'
                    "
                v-model.number="addData.quantity_charge_base_usa"
                data-vv-name="quantity_charge_base_usa"
              ></v-text-field>
            </v-flex>
            <v-flex
              xs12
              sm10
              md6
              class="px-2"
            >
              <v-text-field
                :label="
                      'Other Quantity Charge (USA) (By default $' +
                        defaultPriceData.customer_other_qtt_charge_usa +
                        ')'
                    "
                v-model.number="addData.quantity_charge_other_usa"
                data-vv-name="quantity_charge_other_usa"
              ></v-text-field>
            </v-flex>
            <v-flex
              xs12
              sm10
              md12
              class="px-2"
            >
              <label
                for="description"
                style="opacity: 0.8; font-size: 14px; margin-bottom: -8px"
              >
                Customer Note
              </label>
              <textarea
                v-model="addData.customer_note"
                class="form-control"
                style="border-bottom: 1px solid blue; font-size: 1.5rem"
                rows="4"
              />
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            style="height:auto"
            @click=";(passwordAlert = false), closeCreateCustomerModal(), $validator.reset()"
            outline
            color="normal"
          >Cancel</v-btn>
          <v-btn
            type="submit"
            style="height:auto; margin-right: 2.5%"
            outline
            color="success"
          >Add</v-btn>
        </v-card-actions>
      </form>

      <form
        id="login_success99"
        @submit.prevent="phoneLogin"
      >
        <input
          type="hidden"
          name="_token"
          value="QH65OXMU7MRnJg6UIS2LucakcxXX5LP88cFsEEwL"
        />
        <input
          id="csrf"
          type="hidden"
          name="csrf"
        />
        <input
          id="code"
          type="hidden"
          name="code"
        />
        <button
          type="submit"
          id="phone"
        ></button>
      </form>
    </v-card>
  </v-dialog>
  <!-- /CREATE USER -->
</template>

<script>
import axios from 'axios'

export default {
  props: [
    'createCustomer',
    'addData',
    'createCustomerModal',
    'checkAlert',
    'closeCreateCustomerModal',
    'emailError',
    'phoneNumberError',
    'validationError',
    'phoneError',
    'defaultPriceData',
    'citiesList'
  ],

  data() {
    return {
      phoneData: {
        code: '',
        csrf: ''
      }
    }
  },

  methods: {
    submitForm(event) {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.createCustomer()
        }
      })
    },

    loginCallback(response) {
      if (response != null) {
        if (response.status === 'PARTIALLY_AUTHENTICATED') {
          this.phoneData.code = response.code
          this.phoneData.csrf = response.state
          $('#phone').click()
        }
      }
    },

    smsLogin() {
      AccountKit.login('PHONE', { countryCode: '+964' }, this.loginCallback)
    },

    phoneLogin() {
      axios.post('/api/phone-login', this.phoneData).then(response => {
        this.addData.phone_number = response.data.data.phone.number
        this.createCustomer()
      })
    }
  }
}
</script>

<style scoped>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/user/createUser.vue